import { render, staticRenderFns } from "./ContactsContentMobile.vue?vue&type=template&id=109973e5&"
import script from "./ContactsContentMobile.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ContactsContentMobile.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109973e5')) {
      api.createRecord('109973e5', component.options)
    } else {
      api.reload('109973e5', component.options)
    }
    module.hot.accept("./ContactsContentMobile.vue?vue&type=template&id=109973e5&", function () {
      api.rerender('109973e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/contacts/components/ContactsContentMobile.vue"
export default component.exports